export default __webpack_public_path__ + "img/bMMVjgVp.42aaa0d2.svg";